// extracted by mini-css-extract-plugin
export var arrowbtn = "carousel_window-module--arrowbtn--ef6bc";
export var back = "carousel_window-module--back--5caf0";
export var carousel = "carousel_window-module--carousel--049f2";
export var carousel_wr = "carousel_window-module--carousel_wr--7ce59";
export var fig = "carousel_window-module--fig--d97c8";
export var figcap = "carousel_window-module--figcap--a7e0b";
export var forw = "carousel_window-module--forw--38844";
export var img = "carousel_window-module--img--f9af9";
export var img_desk = "carousel_window-module--img_desk--6721f";
export var img_mob = "carousel_window-module--img_mob--7371d";
export var off = "carousel_window-module--off--a29a1";
export var titles = "carousel_window-module--titles--13576";